import { render, staticRenderFns } from "./OrganizationListPage.vue?vue&type=template&id=88877f94&scoped=true"
import script from "./OrganizationListPage.ts?vue&type=script&lang=js&external"
export * from "./OrganizationListPage.ts?vue&type=script&lang=js&external"
import style0 from "./OrganizationListPage.vue?vue&type=style&index=0&id=88877f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88877f94",
  null
  
)

export default component.exports